import { Divider, Typography } from '@mui/material';
import { Box } from '@mui/material';
import React from 'react';

export default function ({ heading, description }) {
	return (
		<Box sx={{ marginBottom: '12px' }}>
			<Typography variant="h6" sx={{ fontWeight: 600}}>
				{heading}
			</Typography>
			<Typography>
				{description}
			</Typography>
		</Box>
	);
}
